import React from "react";
import { Crown, Award } from "lucide-react";
import { RankingUser } from "../../types";

interface RankingItemProps extends RankingUser {
  onClick?: () => void;
}

const RankingItem: React.FC<RankingItemProps> = ({
  rank,
  name,
  points,
  isMe,
  onClick,
}) => {
  let rankStyle = "bg-slate-50 text-slate-500 border-slate-100";
  let icon: React.ReactNode = null;

  if (rank === 1) {
    rankStyle =
      "bg-yellow-50 text-yellow-600 border-yellow-200 shadow-sm shadow-yellow-100";
    icon = (
      <Crown className="w-3.5 h-3.5 absolute -top-1.5 -right-1 text-yellow-500 drop-shadow-sm rotate-12" />
    );
  } else if (rank === 2) {
    rankStyle = "bg-slate-100 text-slate-600 border-slate-200";
  } else if (rank === 3) {
    rankStyle = "bg-orange-50 text-orange-700 border-orange-200";
  }

  const cardBg = isMe
    ? "bg-blue-50/50 border-blue-200 shadow-[0_4px_20px_rgb(59,130,246,0.1)]"
    : "bg-white border-slate-100 shadow-[0_4px_20px_rgb(0,0,0,0.02)]";

  return (
    <div
      onClick={onClick}
      className={`flex items-center justify-between p-3.5 mb-3 ${cardBg} border rounded-xl transition-all relative text-left ${onClick ? "cursor-pointer active:scale-[0.98]" : ""}`}
    >
      <div className="flex items-center gap-4">
        <div className="relative">
          <div
            className={`w-9 h-9 rounded-full flex items-center justify-center font-black text-sm border ${rankStyle}`}
          >
            {rank}
          </div>
          {icon}
        </div>
        <div className="flex flex-col">
          <span
            className={`font-bold text-[15px] ${isMe ? "text-blue-700" : "text-slate-700"}`}
          >
            {name}
          </span>
          {isMe && (
            <span className="bg-blue-600 text-white text-[9px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider mt-0.5 w-max leading-none">
              You
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <Award
          className={`w-4 h-4 ${isMe ? "text-blue-400" : "text-slate-300"}`}
        />
        <div className="flex items-baseline gap-0.5">
          <span
            className={`font-black text-lg ${isMe ? "text-blue-700" : "text-slate-700"}`}
          >
            {points}
          </span>
          <span className="text-[10px] font-bold text-slate-400">pt</span>
        </div>
      </div>
    </div>
  );
};

export default RankingItem;
